// removed by extract-text-webpack-plugin
module.exports = {"container":"style__container___117Kd","containerInner":"style__containerInner___2WLGR","containerInnerContent":"style__containerInnerContent___21c4v","containerInnerContentText":"style__containerInnerContentText___34Es6","containerInnerContentTextLink":"style__containerInnerContentTextLink___1XbuD","containerInnerLogo":"style__containerInnerLogo___2PUN0","containerInnerLogoDesktop":"style__containerInnerLogoDesktop___2FYUT"};


//////////////////
// WEBPACK FOOTER
// ./src/components/footer/style.css
// module id = 1057
// module chunks = 0